var _rect, _g, _rect2, _rect3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1330_29163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1330_29163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 15.8538L17.323 9.13075L16.2692 8.07693L10.6 13.7462L7.74998 10.8962L6.69615 11.95L10.6 15.8538ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM5.3077 19H18.6923C18.7692 19 18.8397 18.9679 18.9038 18.9038C18.9679 18.8397 19 18.7692 19 18.6923V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99997 18.6923 4.99997H5.3077C5.23077 4.99997 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    fill: "#1D4650"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1330_29163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1330_29163)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1330_29163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1330_29163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2292 13.9377L15.7292 8.45858C15.8819 8.3058 16.0556 8.23289 16.25 8.23983C16.4444 8.24678 16.6181 8.32664 16.7708 8.47942C16.9236 8.63219 17 8.80581 17 9.00025C17 9.19469 16.9236 9.36831 16.7708 9.52108L10.7708 15.5211C10.6181 15.6739 10.441 15.7502 10.2396 15.7502C10.0382 15.7502 9.86111 15.6739 9.70833 15.5211L7.22917 13.0419C7.07639 12.8891 7 12.7155 7 12.5211C7 12.3266 7.07639 12.153 7.22917 12.0002C7.38194 11.8475 7.55556 11.7711 7.75 11.7711C7.94444 11.7711 8.11806 11.8475 8.27083 12.0002L10.2292 13.9377Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCheckbox);
export default __webpack_public_path__ + "static/media/filled-checkbox.99922f6f313b987977797dc65d3c0753.svg";
export { ForwardRef as ReactComponent };